export default __webpack_public_path__ + "static/media/fotoku.0a8621bc.JPG";